(async () => {
  if (!customElements.get("featured-collection")) {
    class FeaturedCollection extends HTMLElement {
      constructor() {
        super();
        this.handleResize = this.setCarousel.bind(this);
      }

      connectedCallback() {
        this.setHtmlElements();
        this.setCarousel();
        window.addEventListener("resize", this.handleResize);
      }

      disconnectedCallback() {
        this.destroyCarousel();
        window.removeEventListener("resize", this.handleResize);
      }

      setHtmlElements() {
        this.carousel = this.querySelector("[data-carousel]");
      }

      initCarousel() {
        if (!this.carousel || !(this.carousel instanceof Element)) {
          console.warn("Carousel element not found.");
          return;
        }

        if (!this.swiper) {
          this.swiper = new Swiper(this.carousel, {
            slidesPerView: "auto",
            spaceBetween: 12,
            centeredSlides: true,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
          });
        }
      }

      destroyCarousel() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      setCarousel() {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          if (window.innerWidth <= 849) {
            this.initCarousel();
          } else {
            this.destroyCarousel();
          }
        }, 100);
      }
    }

    customElements.define("featured-collection", FeaturedCollection);
  }
})();

{
  /* <featured-collection>
<div>
</div>
</featured-collection> */
}